import React, { useCallback, useEffect, useState } from "react";
import { FiTrash2, FiMail, FiCheck } from "react-icons/fi";
import { apiRequest } from "../../api";

// Messages sent through the Contact page form.
export default function ContactMessagesAdmin() {
  const [messages, setMessages] = useState(null);
  const [filter, setFilter] = useState("");   // "" | "unread"

  const load = useCallback(async () => {
    const { ok, data } = await apiRequest("/core/contact-messages/", { auth: true });
    setMessages(ok ? data : []);
  }, []);

  useEffect(() => { load(); }, [load]);

  const setRead = async (m, is_read) => {
    await apiRequest(`/core/contact-messages/${m.id}/`, { method: "PATCH", auth: true, body: { is_read } });
    load();
  };

  const remove = async (m) => {
    if (!window.confirm("Delete this message?")) return;
    await apiRequest(`/core/contact-messages/${m.id}/`, { method: "DELETE", auth: true });
    load();
  };

  const shown = (messages || []).filter((m) => filter !== "unread" || !m.is_read);
  const unread = (messages || []).filter((m) => !m.is_read).length;
  const btn = "px-3 py-1.5 rounded-md bg-white/5 border border-navy-border text-xs text-gray-200 inline-flex items-center gap-1.5 hover:border-accent-light";

  return (
    <div className="w-full">
      <h1 className="text-2xl font-bold mb-2">Contact Messages</h1>
      <p className="text-sm text-gray-400 mb-6">Messages sent from the form on the Contact page. Reply to the sender by email or phone.</p>

      <div className="flex gap-2 mb-5">
        {[["", `All (${(messages || []).length})`], ["unread", `Unread (${unread})`]].map(([key, label]) => (
          <button key={key} onClick={() => setFilter(key)} className={`px-4 py-1.5 rounded-full text-sm ${filter === key ? "bg-brand-gradient text-white" : "bg-white/5 border border-navy-border text-gray-300"}`}>
            {label}
          </button>
        ))}
      </div>

      <div className="space-y-4">
        {messages === null && <p className="text-gray-400">Loading...</p>}
        {messages && shown.length === 0 && <div className="bg-navy border border-navy-border rounded-xl p-8 text-center text-gray-500">No messages here.</div>}
        {shown.map((m) => (
          <div key={m.id} className={`bg-navy border rounded-xl p-5 ${m.is_read ? "border-navy-border" : "border-accent-light/50"}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="font-semibold text-white">
                  {m.name} {!m.is_read && <span className="ml-2 px-2 py-0.5 rounded-full bg-accent-light text-navy-darker text-[10px] font-bold">NEW</span>}
                </p>
                <p className="text-sm text-gray-400">
                  <a href={`mailto:${m.email}`} className="text-accent-light hover:underline">{m.email}</a>
                  {m.phone && <> &middot; {m.phone}</>}
                </p>
                <p className="text-xs text-gray-600 mt-0.5">{new Date(m.created_at).toLocaleString()}</p>
              </div>
              <div className="flex items-center gap-2">
                <a
                  href={`mailto:${m.email}?subject=${encodeURIComponent(`Re: ${m.subject || "Your message"}`)}`}
                  onClick={() => !m.is_read && setRead(m, true)}
                  className={btn}
                ><FiMail size={13} /> Reply</a>
                <button onClick={() => setRead(m, !m.is_read)} className={btn}><FiCheck size={13} /> {m.is_read ? "Mark unread" : "Mark read"}</button>
                <button onClick={() => remove(m)} className="p-1.5 rounded-md text-red-400 hover:bg-red-500/10" aria-label="Delete"><FiTrash2 size={15} /></button>
              </div>
            </div>
            {m.subject && <p className="mt-3 font-medium text-gray-100">{m.subject}</p>}
            <p className="mt-1 text-sm text-gray-300 whitespace-pre-line">{m.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
